module.exports = __webpack_public_path__ + "static/img/refund.bb1c4069.svg";